module.exports = "<app-sitemenu [loggedIn]=\"loggedIn\"></app-sitemenu>\n<app-topmenu [loggedIn]=\"loggedIn\"></app-topmenu>\n<div class=\"wrap\" [class.out]=\"!loggedIn\" id=\"js--wrap\">\n\t<router-outlet></router-outlet>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main